import { DynamicProfileComponentsDictionary, ProfileComponentItem } from '@linkdev/shared-library';
import { Injectable } from "@angular/core";
import { CorporateProfileComponent } from '@linkdev/access-manage-library';
import { IndividualProfileComponent, SSAInternalComponent } from '@linkdev/ssa-shared';
import { PersonalProfileComponent, OrganizationProfileComponent } from '@linkdev/ssa-shared';

@Injectable()
export class ProfileComponentsDictionary implements DynamicProfileComponentsDictionary {
    public getDynamicComponents(): ProfileComponentItem[] {
        return this._dynamicComponents;
    }

    private _dynamicComponents: ProfileComponentItem[] = [
        new ProfileComponentItem(PersonalProfileComponent, "PersonalProfileComponent"),
        new ProfileComponentItem(IndividualProfileComponent, "IndividualProfileComponent"),
        new ProfileComponentItem(CorporateProfileComponent, "CorporateProfileComponent"),
        new ProfileComponentItem(OrganizationProfileComponent, "OrganizationProfileComponent"),
        new ProfileComponentItem(SSAInternalComponent, "SSAInternalComponent")
    ]

}
